const STORAGE_PREFIX = 'pegasus-news-seen:';
export const NEWS_SEEN_EVENT = 'pegasus-news-seen-updated';

const storageKey = (userId) => `${STORAGE_PREFIX}${userId}`;

/** Login JSON has name/token only. Email is stored separately as base64. */
export const newsUserId = (user) => {
    if (user?._id) return String(user._id);
    if (user?.email) return String(user.email);
    try {
        const encoded = localStorage.getItem('email');
        if (encoded) return atob(encoded);
    } catch {
        /* ignore */
    }
    return user?.name ? String(user.name) : '';
};

export const getSeenIds = (userId) => {
    if (!userId) return [];
    try {
        const raw = localStorage.getItem(storageKey(userId));
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

export const markSeen = (userId, articleId) => {
    if (!userId || !articleId) return;
    const seen = getSeenIds(userId);
    if (seen.includes(articleId)) return;
    localStorage.setItem(storageKey(userId), JSON.stringify([...seen, articleId]));
    window.dispatchEvent(new CustomEvent(NEWS_SEEN_EVENT, { detail: { userId, articleId } }));
};

export const isUnread = (userId, articleId) => {
    if (!userId || !articleId) return false;
    return !getSeenIds(userId).includes(articleId);
};

export const getUnreadCount = (userId, articles = []) => {
    if (!userId) return 0;
    const seen = new Set(getSeenIds(userId));
    return articles.filter((a) => !seen.has(a.id)).length;
};
